import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  Renderer2,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AppEventsService } from 'src/app/services/app-events.service';
import { AuthService } from 'src/app/services/auth.service';

interface IMenuItem {
  title: string;
  icon: string;
  route: string;
  permissions: string[];
  submenus?: {
    title: string;
    route: string;
    badgeText?: string;
    permissions?: string[];
  }[];
  img?: string;
  setImg?: boolean;
  urlImg?: string;
  redirect?: boolean;
}

const allRoles = [
  'ADMIN',
  'SUPERADMIN',
  'CUSTOMER',
  'ENTERPRISE',
  'ENTERPRISE_POSTPAY',
];

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit {
  menuItems: IMenuItem[] = [
    {
      title: 'Inicio',
      icon: 'home',
      route: 'home',
      permissions: ['ADMIN', 'CUSTOMER'],
      setImg: false,
      redirect: false,
    },
    {
      title: 'Inicio',
      icon: 'home',
      route: 'home',
      permissions: ['ENTERPRISE', 'ENTERPRISE_POSTPAY', 'SUPERADMIN'],
      setImg: false,
      redirect: false,
    },
    {
      title: 'Transacciones',
      icon: 'bi bi-arrow-left-right',
      route: 'all-transactions',
      setImg: false,
      urlImg: '',
      permissions: ['SUPERADMIN'],
      redirect: false,
    },
    {
      title: 'Colaboradores',
      icon: 'bi bi-people-fill',
      route: 'all-collaborators',
      setImg: false,
      permissions: ['SUPERADMIN'],
      redirect: false,
    },
    {
      title: 'Gestión de usuarios',
      icon: 'user-management',
      route: 'user-management',
      setImg: false,
      permissions: ['SUPERADMIN'],
      submenus: [
        {
          title: 'Administradores',
          route: 'administrators',
          permissions: ['SUPERADMIN'],
        },
        {
          title: 'Compañías',
          route: 'contractors',
        },
        {
          title: 'Colaboradores',
          route: 'collaborators',
          permissions: ['CUSTOMER'],
        },
      ],
      redirect: false,
    },
    {
      title: 'Asignar saldos',
      icon: 'asign-funds',
      route: 'appropriate-funds/assign-prepaid',
      permissions: ['SUPERADMIN'],
      setImg: false,
      redirect: false,
    },
    {
      title: 'Asignar fondos',
      icon: 'asign-funds',
      route: 'asign-funds-table',
      permissions: ['ENTERPRISE'],
      setImg: false,
      redirect: false,
    },
    /* {
      title: 'Legal Entity',
      icon: 'legal-entity',
      route: 'legal-entity',
      setImg: false,
      permissions: ['SUPERADMIN'],
    },*/
    {
      title: 'Facturas', //facturacion para los otros roles
      icon: 'transactions',
      route: 'payments-table',
      setImg: false,
      permissions: ['ADMIN', 'SUPERADMIN',],
      redirect: false,
      submenus: [
        {
          title: 'Compañías',
          route: 'prepaid',
        },
        {
          title: 'Cuentas Personales',
          route: 'personal',
        },
      ],
    },
    {
      title: 'Facturas', //facturacion para los otros roles
      route: 'payments-table/prepaid',
      icon: 'transactions',
      setImg: false,
      permissions: ['ENTERPRISE'],
      redirect: false,
    },
    {
      title: 'Facturas',
      route: 'payments-table/postpaid',
      icon: 'transactions',
      setImg: false,
      permissions: ['ENTERPRISE_POSTPAY'],
      redirect: false,
    },
    {
      title: 'Campañas',
      icon: 'bi bi-shop-window',
      route: 'events',
      setImg: true,
      urlImg: 'assets/svg/events-icon.svg',
      permissions: ['SUPERADMIN'],
      redirect: false,
    },
    {
      title: 'Terminales',
      icon: 'device-ssd',
      route: 'terminals',
      setImg: true,
      urlImg: 'assets/svg/terminal.svg',
      permissions: ['SUPERADMIN', 'ADMIN'],
      redirect: false,
    },
    {
      title: 'Comercios Asociados',
      icon: 'shop-retail',
      route: 'retails',
      setImg: true,
      urlImg: 'assets/img/shop.png',
      permissions: ['SUPERADMIN'],
      redirect: false,
    },
    //
    /* {
      title: 'Facturación', //facturacion para los otros roles
      route: 'payments-table',
      icon: 'transactions',
      setImg: false,
      permissions: ['ADMIN', 'SUPERADMIN'],
      submenus: [
        {
          title: 'Prepago',
          route: 'prepaid',
        },
        {
          title: 'Postpago',
          route: 'postpaid',
        },
      ],
      redirect: false,
    }, */
    {
      title: 'Transacciones', //facturacion para los otros roles
      route: 'transactions',
      icon: ' bi-arrow-left-right',
      setImg: false,
      permissions: ['ENTERPRISE', 'ENTERPRISE_POSTPAY'],
      redirect: false,
    },
    // {
    //   title: 'Reportes',
    //   icon: 'reports',
    //   route: 'reports',
    //   permissions: [],
    // },
    {
      title: 'Gestión de usuarios',
      icon: 'user-management',
      route: 'user-management/contractors',
      setImg: false,
      permissions: ['ADMIN'],
      submenus: [
        {
          title: 'Contratistas',
          route: 'contractors',
        },
      ],
      redirect: false,
    },
    {
      title: 'Colaboradores',
      icon: 'bi bi-people-fill',
      route: 'user-management/collaborators',
      setImg: false,
      permissions: ['CUSTOMER', 'ENTERPRISE', 'ENTERPRISE_POSTPAY'],
      redirect: false,
    },
    {
      title: 'Sucursales',
      icon: 'shop',
      route: 'user-management/branches-table',
      setImg: false,
      permissions: ['ENTERPRISE', 'ENTERPRISE_POSTPAY'],
      redirect: false,
    },
    {
      title: 'Generar QR',
      icon: '  bi-qr-code',
      route: 'generate-qr',
      setImg: true,
      urlImg: 'assets/svg/qr-code.svg',
      permissions: ['SUPERADMIN'],
      redirect: false,
    },
    {
      title: 'Ayuda',
      icon: 'bi bi-headset',
      route: 'https://www.aramarkpay.cl/soporte',
      setImg: false,
      permissions: allRoles,
      redirect: true,
    },
    {
      title: 'Términos y Condiciones',
      icon: 'bi bi-book-half',
      route: 'terms-conditions/terms-conditions-edit',
      setImg: false,
      permissions: ['SUPERADMIN'],
      redirect: false,
    },
  ];
  currentUrl!: string;
  toggled: boolean = false;
  lastWidth: number = 0;

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    const width = event.target.innerWidth;
    if (width < 768) this.hideSidebar();
    if (width >= 768 && width > this.lastWidth) this.showSidebar();
  }

  constructor(
    private router: Router,
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private appEventsSvc: AppEventsService,
    private authSvc: AuthService
  ) { }

  private getUrl(url: string) {
    return url.replace('/', '').split('/')[0];
  }

  ngOnInit(): void {
    this.currentUrl = this.getUrl(this.router.url);
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = this.getUrl(event.url);
      }
    });
    this.appEventsSvc.showSidebarSubject.subscribe((val) => {
      if (val) {
        this.renderer.removeClass(this.elementRef.nativeElement, 'd-none');
      } else {
        this.renderer.addClass(this.elementRef.nativeElement, 'd-none');
      }
    });
  }

  logout() {
    this.authSvc.logout();
    this.router.navigate(['/auth']);
  }

  hideSidebar() {
    if (window.screen.width < 768) {
      this.appEventsSvc.setShowSidebar(false);
      this.toggled = false;
    }
  }

  showSidebar() {
    this.appEventsSvc.setShowSidebar(true);
    this.toggled = false;
  }

  toggleSidebar() {
    this.toggled = !this.toggled;
  }
}
